var aayurved = [
  {
    id: 1,
    image_url: "https://onemg.gumlet.io/image/upload/sdzsl07upy0u3sxckqyj.jpg",
    name: "Ashwagandha",
  },
  {
    id: 2,
    image_url: "https://onemg.gumlet.io/image/upload/qh2zgvxci0mazembq9rs.jpg",
    name: "Shilajit",
  },
  {
    id: 3,
    image_url: "https://onemg.gumlet.io/image/upload/un9aranb98jy80ihbj95.jpg",
    name: "Giloy",
  },
  {
    id: 4,
    image_url: "https://onemg.gumlet.io/image/upload/irazjokdgsiiuw6abiph.jpg",
    name: "Amla",
  },
  {
    id: 5,
    image_url: "https://onemg.gumlet.io/image/upload/qclivlzn55hbfukf2mjn.jpg",
    name: "Aloe vera",
  },
  {
    id: 6,
    image_url: "https://onemg.gumlet.io/image/upload/q3lxrcgk8iok8lvx9lap.jpg",
    name: "Hone",
  },
  {
    id: 7,
    image_url: "https://onemg.gumlet.io/image/upload/uc2vwlgcfu9x2ylp9v0w.jpg",
    name: "Coconut",
  },
];
export default aayurved;
